import InterviewQuestions from "../modules/Interviews/InterviewQuestions";
import Dashboard from "../pages/Dashboard";
import Interviews from "../pages/Interviews";
import UserManagement from "../pages/UserManagement";
import CandidateProfile from "../pages/CandidateProfile";
import CandidateProfileDetail from "../pages/CandidateProfile/CandidateProfileDetail";
import EmailActivityPage from "../pages/EmailActivity";

export const privateRoutes = [
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/interviews",
    element: <Interviews />,
  },
  {
    path: "/interviews/:id",
    element: <InterviewQuestions />,
  },
  {
    path: "/user-management",
    element: <UserManagement />,
  },
  {
    path: "/candidates",
    element: <CandidateProfile />,
  },
  {
    path: "/candidates/:candidateKey",
    element: <CandidateProfileDetail />,
  },
  {
    path: "/email-activity",
    element: <EmailActivityPage />,
  },
];
